{
  "receive.heading": "受領",
  "receive.description": "この表には、受信プロセスのコンテナとパッケージのステータス、サイクル、および数が表示されます",
  "receive.filter.title": "オプション",
  "receive.filter.cycle": "サイクル",
  "receive.current_planned": "現在計画中",
  "receive.current_actual": "現在の到着実績",
  "receive.other": "その他/予定外到着実績",
  "CPT.": "CPT",
  "CPT.cpt": "CPT",
  "CPT.induct_by": "によって誘導する",
  "CPT.stow_by": "収納",
  "package.cpt": "CPT",
  "receive.overall_status": "全体ステータス",
  "receive.packages": "パッケージ",
  "receive.predicted_dispatch": "作業計画された荷物（LMCP",
  "receive.container_planned_volume": "コンテナ予定ボリューム",
  "receive.current_cycle_planned": "現在の予定サイクル",
  "receive.current_cycle_actual": "作業サイクルの到着荷物（マニフェスト通りの荷物）",
  "receive.other_cycles": "他サイクル/予定外の到着荷物（マニフェストサイクル違いの荷物）",
  "receive.total": "到着荷物の合計（マニフェストによらない全ての到着荷物",
  "receive.current_status": "現在のステータス",
  "receive.manifested": "マニフェスト済み",
  "receive.manifested.unplanned": "ソートプラン予定の荷物（マニフェスト上でソートプラン予定の荷物）",
  "receive.in_transit": "輸送中",
  "receive.in_transit.unplanned": "ソートプラン済みの荷物（DSへ移送中）",
  "receive.arrived": "ソートプラン済みの荷物（DSへ到着済）",
  "receive.arrived.unplanned": "ソートプラン外の荷物（DSへ到着済）",
  "receive.marked_for_reprocess": "ソートプラン済みの荷物（再インダクション）",
  "receive.marked_for_reprocess.unplanned": "ソートプラン外の荷物（再インダクション）",
  "receive.inducted": "インダクション済み",
  "receive.stow_buffered": "バッファー付きで詰め込む",
  "receive.stowed": "ストー済み",
  "receive.sidelined": "サイドライン済み",
  "receive.group_by": "グループ化",
  "linehaul.linehauls": "長距離輸送",
  "linehaul.status": "ステータス",
  "linehaul.arrival": "到着",
  "linehaul.details": "詳細",
  "linehaul.vrid": "VRID",
  "linehaul.origin": "輸送元",
  "linehaul.location": "場所",
  "linehaul.planned": "予定",
  "linehaul.actual": "実績",
  "linehaul.volume": "ボリューム",
  "linehaul.FMC": "FMC",
  "linehaul.unloadSequence": "アンロードシーケンス",
  "linehaul.inyard": "ヤード",
  "linehaul.arrived": "到着済み",
  "linehaul.incoming": "到着",
  "linehaul_detail.receive": "受領",
  "linehaul_detail.linehaul_details": "長距離輸送の詳細",
  "linehaul_detail.linehaul": "長距離輸送 ",
  "linehaul_detail.from": "発送元",
  "linehaul_detail.departed": "出庫済み",
  "linehaul_detail.arrived": "到着済み",
  "linehaul_detail.options": "オプション",
  "linehaul_detail.id": "ID",
  "linehaul_detail.type": "タイプ",
  "linehaul_detail.pending_induct": "インダクション保留中 ",
  "linehaul_detail.total": "合計 ",
  "linehaul_filter.packagesize": "パッケージサイズ",
  "linehaul_filter.ead": "ステーションEAD",
  "linehaul_filter.cycle": "サイクル",
  "linehaul_filter.cluster": "クラスター",
  "linehaul_filter.otherattributes": "その他の属性",
  "linehaul_filter.clear_all": "すべてクリア",
  "induct.heading": "インダクション",
  "induct.description": "このページには、インダクトプロセスのコンテナとパッケージのステータス、サイクル、および数が表示されます",
  "induct.induct": "インダクション",
  "induct.induct_area": "インダクションエリア",
  "induct.active_associate": "アクティブなアソシエイト",
  "induct.induct_rate": "インダクションレート",
  "induct.total_inducted": "インダクション合計",
  "induct.container": "コンテナ",
  "induct.container_id": "ID",
  "induct.type": "タイプ",
  "induct.pending_induct": "インダクション保留中 ",
  "induct.total": " 合計",
  "induct.max_induct_rate": "Max Induct rate",
  "induct.station_percentage": "% of station",
  "induct.successful_percentage": "% Successful",
  "induct.kickout": "Kickout",
  "induct.noread": "NoRead",
  "induct.timeout": "Timeout",
  "induct.failed_verification": "Failed Verification",
  "induct.sidelined": "Sidelined",
  "induct.cycle": "サイクル",
  "associate.heading": "インダクションアソシエイツ",
  "associate.description": "このページには、インダクトアソシエイトのパフォーマンスデータと現在の作業場所が表示されます",
  "associate.option": "オプション",
  "associate.active": "アクティブ",
  "associate.associates": "アソシエイト",
  "associate.associate": "アソシエイト",
  "associate.pph": "PPH",
  "associate.hours": "時",
  "associate.total_packages": "パッケージ合計",
  "associate.location": "場所",
  "associate.inactive_period": "非アクティブ期間",
  "package.package_summary": "パッケージサマリー",
  "package.tracking_id": "追跡ID",
  "package.last_scan_date_time": "最終スキャン",
  "package.minutes_in_state": "状態経過時間(分)",
  "package.package_state": "状態",
  "package.package_reason": "理由",
  "package.location": "場所",
  "package.cycle": "サイクル",
  "package.sort_zone": "ソートゾーン",
  "package.cluster": "クラスター",
  "package.EAD": "ステーションEAD",
  "package.size": "サイズ",
  "package.station_code": "行き先",
  "package.package_list": "パッケージリスト",
  "induct.error": "エラーが発生しました",
  "status.current_cycle_planned": "ソートプラン済みの荷物",
  "status.planned_inducted_cycle": "インダクト済みの荷物(ソートプラン内)",
  "status.unplanned_inducted_cycle": "インダクト済みの荷物(ソートプラン外)",
  "status.total_inducted_cycle": "合計インダクト数",
  "status.current_planned": "現在計画中",
  "status.planned_inducted": "現在の誘導実績",
  "status.unplanned_inducted": "その他/計画外の誘導実績",
  "tooltip.planned_inducted": "到着した、または導入された、または再導入が保留されている計画出荷",
  "tooltip.unplanned_inducted": "駅に到着したその他の貨物",
  "tooltip.total_inducted": "現在の到着時間とその他/計画外の到着時間実際",
  "tooltip.manifested": "今回予定されている、配送ステーション向けに計画されているトラックに明示された出荷",
  "tooltip.unplanned_manifested": "配送ステーションで計画されているトラックに明示されている、今回は計画されていない貨物",
  "tooltip.in_transit": "今回予定されている、配送ステーションへの輸送中のトラックでの出荷",
  "tooltip.unplanned_in_transit": "配送ステーションへの輸送中のトラックにある、今回は計画されていない貨物",
  "tooltip.arrived": "配送ステーションに到着した今回の予定の出荷",
  "tooltip.unplanned_arrived": "配送ステーションに到着した、今回は予定されていない貨物",
  "tooltip.marked_for_reprocess": "今回予定されている、Fixitで解決された出荷",
  "tooltip.unplanned_marked_for_reprocess": "Fixitを介して解決された、今回は計画されていない出荷",
  "tooltip.inducted": "現在このパッケージ状態にあり、この期間中に正常に導入された出荷",
  "tooltip.stowed": "現在このパッケージ状態にあり、この期間中に正常に収納された貨物",
  "tooltip.sidelined": "現在パッケージ状態が保留（サイドライン化）であり、この期間中に入荷がサイドライン化された貨物",
  "tooltip.current_cycle_planned": "ソートプラン(RTW)のマニフェストボリューム",
  "tooltip.planned_cycle_inducted": "インダクトされた荷物の中でソートプランに含まれている数",
  "tooltip.unplanned_cycle_inducted": "ソートプラン外の荷物でフォースインダクトされた数",
  "tooltip.total_inducted_cycle": "全てのインダクトされた荷物",
  "tooltip.manifested_cycle": "ソートプランに含まれているが、まだDSに向けて出荷されていない荷物",
  "tooltip.unplanned_manifested_cycle": "ソートプランに含まれず、まだDSに向けて出荷されていない荷物",
  "tooltip.in_transit_cycle": "ソートプランに含まれており、DSに向けて輸送中の荷物",
  "tooltip.unplanned_in_transit_cycle": "ソートプランに含まれず、DSに向けて輸送中の荷物",
  "tooltip.arrived_cycle": "ソートプランに含まれており、DS敷地内に到着済みの荷物",
  "tooltip.unplanned_arrived_cycle": "ソートプランに含まれていないが、DS敷地内に到着済みの荷物",
  "tooltip.marked_for_reprocess_cycle": "ソートプランに含まれており、Problem solve(fixit)処理済みの荷物",
  "tooltip.unplanned_marked_for_reprocess_cycle": "ソートプランに含まれず、Problem solve(fixit)処理済みの荷物",
  "tooltip.inducted_cycle": "現在の作業サイクルでインダクト済みの荷物",
  "tooltip.stowbuffered_cycle": "現在このパッケージ状態にあり、このサイクル中にバッファに正常に詰め込まれた貨物",
  "tooltip.stowed_cycle": "現在の作業サイクルでストー済みの荷物",
  "tooltip.sidelined_cycle": "現在の作業サイクルのインダクトでサイドラインされ、保留(Held)のステータスになった荷物",
  "induct.aslInductArea": "ASLインダクトエリア",
  "tooltip.max_induct_rate": "最大インダクト率",
  "tooltip.induct_rate": "ステーションの割合",
  "tooltip.station_percentage": "成功率",
  "tooltip.successful_percentage": "Percentage of packages that were successfully scanned by the ASL machine.",
  "tooltip.kickout": "Number of packages that were kicked-out during ASL induct.",
  "tooltip.noread": "Number of ASL processed packages where a valid barcode was not read by the entry camera.",
  "tooltip.timeout": "Number of ASL processed package scans which did not receive induct response within the SLA.",
  "tooltip.failed_verification": "Number of ASL processed packages which were not verified by the exit camera.",
  "tooltip.current_planned": "ソートプランナー（RTW）マニフェスト出荷",
  "tooltip.current_arrived": "到着した、または導入された、または再導入が保留されている計画出荷",
  "tooltip.other_unplanned_arrived_actual": "駅に到着したその他の貨物",
  "tooltip.total_arrived_actual": "到着した現在のサイクルとその他/計画外の到着した実際のサイクル",
  "tooltip.non_conveyable_description": "NC: Packages that exceed 42'' in a single dimension. \n FCLM might have different dimension criteria for NC",
  "generic.error": "エラーが発生しました",
  "generic.close": "閉じる",
  "generic.enabled" : "有効",
  "generic.disabled" : "無効",

  "header.induct_management": "インダクション管理",

  "induct_management.induct_setup": "インダクションセットアップ",
  "induct_management.select_cycle": "サイクルを選択",
  "induct_management.current_sort_cycle": "現在のソートサイクル",
  "induct_management.current_cycle_state": "現在のサイクル状態",
  "induct_management.current_force_induct_status": "現在の強制インダクションステータス",
  "induct_management.enable_force_induct": "強制インダクションを有効にする",
  "induct_management.sort_cycle": "ソートサイクル",
  "induct_management.force_induct_sort_cycle": "レシーブした荷物を現在のソートサイクルに強制インダクションする",
  "induct_management.start_sort_cycle": "誘導を開始",
  "induct_management.container_plan_failure" : "コンテナプランの取得中にエラーが発生しました。後でもう一度やり直してください",
  "induct_management.mapped_cycles_failure" : "アクティブサイクルの取得中にエラーが発生しました。後でもう一度やり直してください",
  "induct_management.set_node_operational_failure" : "インダクションサイクルの保存中にエラーが発生しました。後でもう一度やり直してください",
  "induct_management.get_node_operational_failure" : "現在のソートサイクル情報を取得中にエラーが発生しました。後でもう一度やり直してください",
  "induct_management.non_mco_station" : "「このページはまだステーションで有効になっていません。ステーションがマルチサイクル操作をサポートしている場合は、今後の更新にご期待ください:-)」",
  "induct_management.bad_request" : "ドロップダウンから正しいサイクルを選択してください",
  "induct_management.set_node_induct_process_details_success" : "インダクションサイクルは正常に開始されました",
  "induct_management.no_active_container_plans_available" : "このステーションにはアクティブなコンテナプランが設定されていません。後でもう一度やり直してください",
  "induct_management.pick_started_for_the_current_cycle" : "現在のサイクルでピックが開始されたため、誘導がブロックされます",
  "induct_management.start_induct" : "。正しいサイクルに変更して、導入プロセスを開始してください。",
  "common.data_last_updated": "データが最終更新されました",
  "inductmanagement.heading": "インダクションサイクル管理",
  "inductmanagement.description": "このページでは、インダクションのサイクル設定を変更できます",
  "inductmanagement.manage_cycle": "サイクル管理",
  "inductmanagement.force_induct": "フォースインダクト",
  "inductmanagement.noCycles": "使用可能なサイクルがありません",
  "inductmanagement.disableCycle": "サイクルを無効にする",
  "inductmanagement.enableCycle": "サイクルを有効にする",
  "inductmanagement.enterCycle": "サイクルを入力する...",
  "inductmanagement.enterStationCode": "ステーションコードを入力する...",
  "inductmanagement.noStations": "利用できるステーションはありません",
  "inductmanagement.selectStatus": "ステータスを選択...",
  "inductmanagement.enableForceInduct": "フォースインダクトを有効にする",
  "inductmanagement.disableForceInduct": "フォースインダクトを無効にする",
  "inductmanagement.activateSortToRouteError": "追加の ダイナミック タイプのサイクルは有効できません。{cycle} はすでにアクティブです",
  "inductmanagement.activateCycleError": "サイクルの有効中にエラーが発生しました：{cycle}",
  "inductmanagement.deactivateCycleError": "サイクルの無効中にエラーが発生しました：{cycle}",
  "inductmanagement.unselectedWarning": "「有効」をクリックする前に、ノードとサイクルを選択してください",
  "inductmanagement.setForceError": "フォースインダクト設定を更新中にエラーが発生しました：{cycleName}",
  "inductmanagement.deliveryWindowConfiguration": "指定時間の設定",
  "inductmanagement.getConfigFail": "サイクルの設定を取り出しながら、エラーが発生しました",
  "inductmanagement.setConfigFail": "サイクルの設定を保存しながら、エラーが発生しました",
  "inductmanagement.parallelNotEnabled": "このステーションには、パラレルインダクト画面は有効されていません",
  "inductmanagement.notEnabled": "こちらのステーションには、指定時間の設定ページが有効されていません",
  "inductmanagement.saveSuccess": "設定への変更が成功的に送りました。入ってくる指定時間パッケージへの変更は、効果が上がることが60分までかかる可能性があります",
  "inductmanagement.noWindowsConfigured": "設定した指定時間がありません。指定時間を追加するように、「編集」をクリックしてください",
  "inductmanagement.start": "開始時間",
  "inductmanagement.end": "完了時間",
  "inductmanagement.addNewWindow": "時間を追加",
  "inductmanagement.deliveryWindow": "指定時間",
  "inductmanagement.cycles": "サイクル",
  "inductmanagement.save": "保存",
  "inductmanagement.edit": "編集",
  "inductmanagement.submit": "送信",
  "inductconfig.noActiveLanes": "すべてのレーンが非アクティブまたはホールドレーンです。パレットやカート用のレーンが残っていません。",
  "inductconfig.noCartLanes": "すべてのレーンが非アクティブ、ホールドまたはパレットレーンです。カート用のレーンが残っていません。",
  "inductconfig.noBeltsConfigured": "インダクトベルトが設定されていません。少なくとも1つのベルトを追加してください。",
  "inductconfig.holdLaneWarning": "ホールドレーンが設定されていません。このサイクル中にコンテナを保持できません。続行しますか？",
  "inductconfig.singleBeltWarning": "アクティブなベルトが1つだけ設定されています。このベルトがダウンすると、パッケージを投入できません。続行しますか？",
  "inductconfig.inactiveHoldOverlap": "非アクティブレーン {lanes} はホールドレーンと重複できません。",
  "inductconfig.inactivePalletOverlap": "非アクティブレーン {lanes} はパレットレーンと重複できません。",
  "inductconfig.palletLanes": "パレットレーン",
  "inductconfig.priorityLaneCount": "優先レーン数",
  "inductconfig.priorityLaneCountHint": "優先レーン数を入力してください（例：25）",
  "inductconfig.beltNoContainerTypes": "1つ以上のベルトにコンテナタイプが選択されていません。各ベルトに少なくとも1つのコンテナタイプを選択してください。",
  "inductconfig.beltNoCubeTypes": "1つ以上のベルトにキューブタイプが選択されていません。各ベルトに少なくとも1つのキューブタイプを選択してください。",
  "inductconfig.noActiveBelts": "アクティブなインダクトベルトが設定されていません。パッケージを処理するには、少なくとも1つのベルトがアクティブである必要があります。",
  "inductconfig.containerTypeNotCovered": "1つ以上のコンテナタイプがアクティブなベルトに割り当てられていません。すべてのコンテナタイプは少なくとも1つのアクティブなベルトでカバーされる必要があります。",
  "inductconfig.cubeTypeNotCovered": "1つ以上のキューブタイプがアクティブなベルトに割り当てられていません。すべてのキューブタイプは少なくとも1つのアクティブなベルトでカバーされる必要があります。",
  "inductconfig.invalidLaneEntered": "無効なレーンが入力されました。有効なレーン識別子を入力してください。",
  "inductconfig.selectCycleBeforeUpload": "アップロードを実行する前にサイクルを選択してください。",
  "inductconfig.invalidCycleInCsv": "CSVのサイクルが無効または未入力です。有効なサイクルを入力してください。"
}
